// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const LaborStats = t.struct({
    averageDiagonsticsHours: t.maybe(t.Number),
    averageRepairHours: t.maybe(t.Number),
    averageReplacementHours: t.maybe(t.Number),
    diagnosticOccurancesNumber: t.maybe(t.Number),
    industryInd: t.maybe(t.String),
    partFamily: t.maybe(t.String),
    partNumber: t.maybe(t.String),
    repairOccurancesNumber: t.maybe(t.Number),
    repairReplaceIndicator: t.maybe(t.String),
    repairReplaceText: t.maybe(t.String),
    replacementOccurancesNumber: t.maybe(t.Number)
}, {
    name: 'LaborStats',
    strict: true
});

export const getDefaultState = () => new LaborStats({});

export default LaborStats;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/labor-stats.js